import { render, staticRenderFns } from "./Frontpage.vue?vue&type=template&id=f9a1f668&"
import script from "./Frontpage.vue?vue&type=script&lang=js&"
export * from "./Frontpage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports